import React from 'react';

export const ElementalLogo = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M12 2L2 12L12 22L22 12L12 2Z" fill="currentColor" fillOpacity="0.1" stroke="currentColor" strokeWidth="1"/>
        <path d="M12 6V12H18" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round"/> {/* Air */}
        <path d="M6 12H12V18" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round"/> {/* Earth */}
        <path d="M12 12L8 8M12 12L16 16" stroke="#3b82f6" strokeWidth="1.5" strokeLinecap="round"/> {/* Water */}
        <path d="M12 12L16 8M12 12L8 16" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round"/> {/* Fire */}
    </svg>
);